export const ClockYellowIcon = ({
  strokeColor = "var(--color-yellow)",
  ...props
}: any) => (
  <svg {...props} width="15" height="16" viewBox="0 0 15 16" fill="none">
    <g id="Icons All">
      <path
        id="Vector"
        d="M7.45185 13.7221C10.6381 13.7221 13.2211 11.1391 13.2211 7.95282C13.2211 4.76656 10.6381 2.18359 7.45185 2.18359C4.26559 2.18359 1.68262 4.76656 1.68262 7.95282C1.68262 11.1391 4.26559 13.7221 7.45185 13.7221Z"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        id="Vector_2"
        d="M7.21371 4.9707L7.21338 8.29044L9.55744 10.6345"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);
